import { render, staticRenderFns } from "./CompanyBusiness.vue?vue&type=template&id=d612ad84&scoped=true&"
import script from "./CompanyBusiness.vue?vue&type=script&lang=js&"
export * from "./CompanyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBusiness.vue?vue&type=style&index=0&id=d612ad84&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d612ad84",
  null
  
)

export default component.exports